// Schema.org structured data for Geigenbau Jacobi
const baseSchema = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  name: "Geigenbaumeister Andreas Jacobi",
  url: "https://geigenbau-jacobi.de",
  telephone: "+49-6722-971982",
  email: "kontakt@geigenbau-jacobi.de",
  address: {
    "@type": "PostalAddress",
    streetAddress: "Bischof-Blum-Platz 9",
    addressLocality: "Geisenheim",
    addressRegion: "Rheingau",
    postalCode: "65366",
    addressCountry: "DE",
  },
  geo: {
    "@type": "GeoCoordinates",
    latitude: "49.983099",
    longitude: "7.96689",
  },
  priceRange: "€€€",
  serviceArea: {
    "@type": "GeoCircle",
    geoMidpoint: {
      "@type": "GeoCoordinates",
      latitude: "49.983099",
      longitude: "7.96689",
    },
    geoRadius: "100000",
  },
  founder: {
    "@type": "Person",
    name: "Andreas Jacobi",
  },
  sameAs: ["https://geigenbau-jacobi.de"],
  vatID: "DE812653016",
};

export const businessSchemaDE = {
  ...baseSchema,
  description:
    "Geigenbaumeister spezialisiert auf Analyse, Dokumentation, Reparatur und Restaurierung von Streichinstrumenten",
  hasOfferCatalog: {
    "@type": "OfferCatalog",
    name: "Geigenbau Services",
    itemListElement: [
      {
        "@type": "Offer",
        itemOffered: {
          "@type": "Service",
          name: "Instrumentenanalyse & Dokumentation",
          description:
            "Professionelle Analyse und Dokumentation von Streichinstrumenten",
        },
      },
      {
        "@type": "Offer",
        itemOffered: {
          "@type": "Service",
          name: "Reparatur & Restaurierung",
          description:
            "Reparatur und Restaurierung von Geigen, Bratschen, Celli und Kontrabässen",
        },
      },
      {
        "@type": "Offer",
        itemOffered: {
          "@type": "Product",
          name: "Streichinstrumente",
          description:
            "Verkauf und Vermietung von hochwertigen Streichinstrumenten",
        },
      },
    ],
  },
  founder: {
    ...baseSchema.founder,
    jobTitle: "Geigenbaumeister",
  },
};

export const businessSchemaEN = {
  ...baseSchema,
  alternateName: "Master Violin Maker Andreas Jacobi",
  description:
    "Master violin maker specialized in analysis, documentation, repair and restoration of stringed instruments",
  hasOfferCatalog: {
    "@type": "OfferCatalog",
    name: "Violin Making Services",
    itemListElement: [
      {
        "@type": "Offer",
        itemOffered: {
          "@type": "Service",
          name: "Instrument Analysis & Documentation",
          description:
            "Professional analysis and documentation of stringed instruments",
        },
      },
      {
        "@type": "Offer",
        itemOffered: {
          "@type": "Service",
          name: "Repair & Restoration",
          description:
            "Repair and restoration of violins, violas, cellos and double basses",
        },
      },
      {
        "@type": "Offer",
        itemOffered: {
          "@type": "Product",
          name: "Stringed Instruments",
          description: "Sale and rental of high-quality stringed instruments",
        },
      },
    ],
  },
  founder: {
    ...baseSchema.founder,
    jobTitle: "Master Violin Maker",
  },
};

// Default export for backward compatibility
export const businessSchema = businessSchemaDE;
